module.exports = __webpack_public_path__ + "static/media/1000864.c24209ad.png";